import { TypeCloudinaryImageJSON } from 'hello_baby/types/guides'

const IS_MOVIE_TYPE = /\.(mov|mp4|webm|ogg)$/i
const IS_VERSION_URL_PART = /^v\d+/

export const cloudinaryPdfToJpg = (url: string) => {
  if (!url) return url
  return url.replace('.pdf', '.jpg')
}

export const getCloudinaryUrl = (
  cloudinaryJSON?: TypeCloudinaryImageJSON | TypeCloudinaryImageJSON[]
) => {
  if (!cloudinaryJSON) return undefined
  if (Array.isArray(cloudinaryJSON)) {
    if (cloudinaryJSON.length > 0) {
      if ('secureUrl' in cloudinaryJSON[0]) {
        return cloudinaryPdfToJpg(cloudinaryJSON[0].secureUrl)
      }
    }
    return undefined
  }
  if ('secureUrl' in cloudinaryJSON)
    return cloudinaryPdfToJpg(cloudinaryJSON.secureUrl)
  return undefined
}

export const cloudinaryThumbnailUrl = (
  cloudinaryJSON?: TypeCloudinaryImageJSON | TypeCloudinaryImageJSON[],
  transformGif = false
) => {
  if (!cloudinaryJSON) return undefined

  let secureUrl = Array.isArray(cloudinaryJSON)
    ? cloudinaryJSON[0].secureUrl
    : cloudinaryJSON.secureUrl

  if (!secureUrl) return undefined

  if (transformGif && secureUrl.includes('.gif')) {
    secureUrl = secureUrl.replace('.gif', '.jpg')
  }

  if (secureUrl.includes('.pdf')) {
    secureUrl = cloudinaryPdfToJpg(secureUrl)
  }

  return secureUrl.replace('upload/', 'upload/t_MessageCenter-Thumbnail/')
}

export const cloudinaryAspectRatioTransform = (
  url: string,
  ratio: number
): string => url.replace('upload/', `upload/ar_${ratio},c_thumb/`)

export const cloudinaryAspectRationTransformForVideo = (
  url: string,
  ratio: number,
  maxWidth: number
): string =>
  url.replace(
    'upload/',
    `upload/b_blurred:400:5,c_pad,w_${Math.round(maxWidth)},h_${Math.round(maxWidth / ratio)}/`
  )

export const cloudinaryGifStillFrameUrl = (url: string, frame = 1): string => {
  if (!url || !url.includes('.gif')) return url

  return url.replace('upload/', `upload/pg_${frame}/`)
}

export const isMovieType = (url: string) => IS_MOVIE_TYPE.test(url)

export const injectMaxWidthForCloudinary = (url: string, width: number) => {
  const parts = url.split('/upload/')
  const transformations = IS_VERSION_URL_PART.test(parts[1])
    ? []
    : parts[1].split('/')[0].split(',')

  // Check if width transformation already exists
  const widthIndex = transformations.findIndex((transformation) =>
    transformation.startsWith('w_')
  )

  if (width) {
    const newWidthTransformation = `w_${Math.round(width)}`
    if (widthIndex !== -1) {
      // Replace existing width transformation
      transformations[widthIndex] = newWidthTransformation
    } else {
      // Add new width transformation
      transformations.push(newWidthTransformation)
    }
  }

  // If no existing transformations
  if (IS_VERSION_URL_PART.test(parts[1])) {
    parts[1] = `${transformations[0]}/${parts[1]}`
  } else {
    const firstSlashIndex = parts[1].indexOf('/')
    if (firstSlashIndex !== -1) {
      parts[1] = transformations.join(',') + parts[1].substring(firstSlashIndex)
    } else {
      parts[1] = transformations.join(',') + parts[1]
    }
  }

  return parts.join('/upload/')
}
